<!-- 处理异常内部结构 可复用 -->
<template>
    <el-form ref="form" :model="model" class="pd-20" :label-width="labelWidth">
        <el-form-item :label="$t('integration.handle_time')" prop="processTime">
            <el-date-picker v-model="model.processTime" type="datetime" style="width: 200px;"
                value-format="timestamp" :clearable="false"></el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('integration.abnormal_cause')" prop="reasonId" :rules="[RuleRequiredFunc($t('integration.please_select_a_reason'))]">
            <el-select :popper-append-to-body="true" v-model="model.reasonId" placeholder="" style="width: 200px;">
                <el-option :label="item.title" :value="item.id" :key="item.id"
                    v-for="item  in reason || reasonList "></el-option>
            </el-select>
        </el-form-item>
        <el-form-item v-if="model.reasonId === 0" prop="reasonText" :rules="[RuleRequiredFunc($t('integration.please_fill_in_the_reason'))]">
            <el-input v-model="model.reasonText" maxlength="20" style="width: 200px;"
                :placeholder="$t('integration.please_fill_in_the_reason')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('integration.remarks')" prop="description">
            <el-input v-model="model.remark" style="width: 200px;" maxlength="250" type="textarea" placeholder=""
                :autosize="{ minRows: 4, maxRows: 4 }"></el-input>
        </el-form-item>
    </el-form>
</template>

<script>
import { exReasons } from "@/api/modules/abnormal";
import { RuleRequiredFunc } from "@/utils/rules";
export default {
    // detail要求是一个数组 因为有可能是处理多个异常
    // 异常原因可选
    props: {
        detail: {
            type: Array,
            default: () => []
        },
        reason: {
            type: Array,
            default: null
        },
        labelWidth: {
            type: String,
            default: '90px'
        }
    },
    data() {
        return {
            model: {
                processTime: Date.now(),
                reasonId: null,
                reasonText: '',
                remark: '',
            },
            reasonList: []
        }
    },
    computed: {
        RuleRequiredFunc: () => RuleRequiredFunc
    },
    watch: {
        detail: {
            handler() {
                if (!this.detail.length) {
                    return;
                }
                if (!this.reason)
                    exReasons({ scope: this.detail[0].sceneId }).then(({ result }) => {
                        result.push({ id: 0, title: $t('integration.custom') });
                        this.reasonList = result;
                    });
            },
            immediate: true
        }
    },
    methods: {
        async getData() {
            await this.$refs['form'].validate();
            if (this.model.reasonId === 0) {
                this.model.reasonId = undefined;
            } else {
                const item = (this.reason || this.reasonList).find(item => item.id === this.model.reasonId);
                if (item) {
                    this.model.reasonText = item.title;
                }

            }
            return this.model;
        },
        // 为实现共用  提供给其他组件使用 维护不用这么麻烦
        handleResult(result, callback) {
            switch (result) {
                case 200:
                    this.$message.success($t('integration.processed_successfully'));
                    if (callback)
                        callback();
                    break;
                case 404:
                    this.$message.error($t('integration.parameter_error'));
                    break;
                case 405:
                    this.$message.error($t('integration.unable_to_find_corresponding_reason'));
                    break;
                case 406:
                    this.$message.error($t('integration.associated_device_not_found'));
                    break;
                case 407:
                    this.$message.error($t('integration.illegal_handler'));
                    break;
                case 408:
                    this.$message.error($t('integration.exception_record_not_found'));
                    break;
                case 409:
                    this.$message.error($t('integration.illegal_description'));
                    break;
                case 410:
                    this.$message.error($t('integration.'));
                    break;
                case 400:
                    this.$message.error($t('integration.system_abnormality'));
                    break;
            }
        },
        reset() {
            this.model = {
                processTime: Date.now(),
                reasonId: null,
                reasonText: '',
                remark: '',
            }
        }
    }
}
</script>

<style scoped lang="scss">
::v-deep .el-scrollbar__view.el-select-dropdown__list {
    max-width: 200px;
}
</style>